export default {
  formId: 'paymentForm',
  formField: {
    amountDue: {
      name: 'amountDue',
      label: 'Amount Due',
      requiredErrorMsg: 'First name is required'
    },
    paymentPlanDue: {
      name: 'paymentPlanDue',
      label: 'Payment Plan Due',
      requiredErrorMsg: 'First name is required'
    },
    paymentAmount: {
      name: 'paymentAmount',
      label: 'First name*',
      requiredErrorMsg: 'First name is required'
    },
    paymentMethod: {
      name: 'paymentMethod',
      label: 'Payment Method*',
      requiredErrorMsg: 'First name is required'
    },
    cardNumber: {
      name: 'cardNumber',
      label: 'Card number*',
      requiredErrorMsg: 'Card number is required',
      invalidErrorMsg: 'Card number is not valid (e.g. 4111111111111)'
    },
    cardExpiration: {
      name: 'cardExpiration',
      label: 'Expiry date*',
      requiredErrorMsg: 'Expiry date is required',
      invalidErrorMsg: 'Expiry date is not valid'
    },
    cardCvv: {
      name: 'cardCvv',
      label: 'CVV*',
      requiredErrorMsg: 'CVV is required',
      invalidErrorMsg: 'CVV is invalid (e.g. 357)'
    },
    firstName: {
      name: 'firstName',
      label: 'First Name*',
      requiredErrorMsg: 'First name is required'
    },
    lastName: {
      name: 'lastName',
      label: 'Last Name on Card*',
      requiredErrorMsg: 'Last name is required'
    },
    address1: {
      name: 'address1',
      label: 'Address Line 1*',
      requiredErrorMsg: 'Address Line 1 is required'
    },
    address2: {
      name: 'address2',
      label: 'Address Line 2'
    },
    city: {
      name: 'city',
      label: 'City*',
      requiredErrorMsg: 'City is required'
    },
    state: {
      name: 'state',
      label: 'State'
    },
    zipCode: {
      name: 'zipCode',
      label: 'Zipcode*',
      requiredErrorMsg: 'Zipcode is required',
      invalidErrorMsg: 'Zipcode is not valid (e.g. 70000)'
    },
    accountType: {
      name: 'accountType',
      label: 'Account Type*',
      requiredErrorMsg: 'Account Type is required'
    },
    routingNumber: {
      name: 'routingNumber',
      label: 'Routing Number*',
      requiredErrorMsg: 'Routing Number is required'
    },
    accountNumber: {
      name: 'accountNumber',
      label: 'Account Number*',
      requiredErrorMsg: 'Account Number is required'
    },
    emailAddress: {
      name: 'emailAddress',
      label: 'Email Address',
      requiredErrorMsg: 'Email Address is required'
    },
    emailAddress2: {
      name: 'emailAddress2',
      label: 'Email Address Confirmation',
      requiredErrorMsg: 'Email Address should match'
    }
  }
};

export const ACH_ACCOUNT_TYPES = [
  { value: '2', label: 'Checking', accessibilityLabel: 'checking ach button' },
  { value: '1', label: 'Saving', accessibilityLabel: 'saving ach button' }
];
